import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ContractService } from '../../account/services/contract.service';

@Component({
  selector: 'app-extends-validity',
  templateUrl: './extends-validity.component.html',
  styleUrls: ['./extends-validity.component.scss']
})
export class ExtendsValidityComponent implements OnInit {

  public contract: any;
  public extendsValidityForm: FormGroup;

  constructor(public activeModal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private contractService: ContractService) { }

  createExtendsValidityForm(): void {
    this.extendsValidityForm = this.formBuilder.group({
      contractStartingDate: [{
        value: this.contract.contractStartingDate,
        disabled: true
      }, [Validators.required]],
      expirationDate: [{
        value: this.contract.expirationDate,
        disabled: false
      }, [Validators.required]]
    })
  }

  ngOnInit(): void {
    this.createExtendsValidityForm();
  }

  save(): void {
    let expirationDate = this.extendsValidityForm.get('expirationDate').value;
    let contract = { ...this.contract }
    contract.expirationDate = expirationDate;
    this.contractService.extendContractValidity(contract).subscribe(() => {
      this.activeModal.close('success');
    });
  }


}
